import React, { useCallback, useEffect } from "react";
import { registerView, View, ViewComponent } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import { Col, Form, Jumbotron, Row } from "react-bootstrap";
import PaymentMultiEshopViewModel from "../../viewModels/multiEshop/paymentMultiEshopViewModel";
import ErrorCard from "../common/error/errorCard";
import Portal from "../eshop/order/components/portal";
import { turnstileSiteKey } from "../../config";
import LoadingModal from "../common/loadingModal/loadingModal";
import Status from "./components/status";
import GooglePay3DSecureModal from "views/eshop/order/components/googlePay3DSecureModal";
import Button from "@edaz/edazkit/Button";
import { IconType } from "@edaz/edazkit/Icon";
import BatchOrderViewModel from "viewModels/multiEshop/batchOrderViewModel";

const paymentMultiEshopView: ViewComponent<PaymentMultiEshopViewModel> = observer(({ vm }) => {
  const error = (code: string) => vm.localizationService.translateGeneral(`errors.${code}`);
  const modalTranslate = (code: string) => vm.localizationService.translateGeneral(`eshop.card.${code}`);
  const formRef = useCallback(node => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  useEffect(() => {
    const handlePageShow = async (event: any) => {
      const reloaded = localStorage.getItem("orderReloaded");
      const lastChargeOrder = vm.storage.getLastChargeOrder();

      if (reloaded === "true") return;

      if (vm.chargeOrderService.chargeOrder.id) {
        await vm.getOrderStatus(vm.chargeOrderService.chargeOrder.id);
      }

      if (vm.isOrderComplete) {
        vm.onOrderIsCompleteCheck(vm.chargeOrderService.chargeOrder.id);
      }
      if (lastChargeOrder && lastChargeOrder.charges[0].licensePlates?.length === 0) {
        vm.chargeOrderService.reset();
        vm.router.navigate(BatchOrderViewModel);
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    window.addEventListener("popstate", handlePageShow);
    window.addEventListener("beforeunload", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  return (
    <Form ref={formRef}>
      <Row id="multiEshop">
        <Col sm={12} lg={8}>
          <Jumbotron className="p-s-0 px-lg-10 py-lg-7 multi-eshop">
            <Status current={4} statusSteps={vm.statusNavigation} translate={vm.translate} />
            {vm.errorMessage && <ErrorCard message={error(vm.errorMessage)} sticky={true} />}
            <fieldset>
              <Row className="mb-4">
                <Col sm={6} xl={6} className="d-flex align-items-center justify-content-start mb-3">
                  <h3 className="mb-0">{vm.translate("paymentMethod")}</h3>
                </Col>
                <Col sm={6} xl={6} className="d-flex align-items-center justify-content-end mb-3">
                  <Button
                    type="button"
                    variant="light-danger"
                    size="sm"
                    style={{ textTransform: "none" }}
                    onClick={vm.resetChargeOrder}
                    iconLeftVariant="light-danger"
                    iconLeft={IconType.Cross}>
                    {vm.translate("cancel")}
                  </Button>
                </Col>
              </Row>
              <Observer>{() => <View vm={vm.selectPaymentMethodViewModel} />}</Observer>
              <div className="mx-4 mt-6 mb-3 border-top" />
              <Observer>{() => <View vm={vm.termsAgreementViewModel} />}</Observer>
            </fieldset>
          </Jumbotron>
        </Col>
        <Col sm={12} lg={4}>
          <Observer>{() => <View vm={vm.summaryViewModel} />}</Observer>
        </Col>
        <div>
          <LoadingModal translate={modalTranslate} isVisible={vm.showPaymentLoadingModal} />
          <GooglePay3DSecureModal isVisible={vm.showGooglePay3DSecureModal} url={vm.googlePay3DSecureUrl} />
        </div>
      </Row>
    </Form>
  );
});

registerView(paymentMultiEshopView, PaymentMultiEshopViewModel);
